/**
 * 工作項目的資源類別 —— 全站單一來源（ticket 31）。
 *
 * 「工作項目」是「某個人對某一筆資產負責」的關係,不是有標題與到期日的任務。
 * accordion 分組、列表的 tag、篩選、刪除阻擋的訊息全部從這份清單長出來,
 * 所以之後要加一類只改這個檔案。
 *
 * 註:設計稿的工作項目列表出現過「設備」tag,但系統沒有對應的資料表,
 * 已確認先當作沒有。若日後確認它是獨立類別,在這裡加一行即可;
 * 若它其實是硬體的再細分,則是既有資料重新分類,那要另外開票。
 */
export const WORK_RESOURCES = [
  { key: "room", label: "機房" },
  { key: "cabinet", label: "機櫃" },
  { key: "hardware", label: "硬體" },
  { key: "software", label: "軟體" },
  { key: "ip", label: "IP" },
  { key: "project", label: "專案" },
  { key: "contract", label: "合約" },
  { key: "vendor", label: "廠商" },
  // WF_v3 調整(票 21):工作項目新增「訊息規則管理」—— 通知規則也是可轉派的
  // 負責關係。key 用 mock 資源註冊名(notify-rule),getResourceStore 才對得到。
  { key: "notify-rule", label: "訊息規則管理" },
];

export const WORK_RESOURCE_KEYS = WORK_RESOURCES.map((r) => r.key);

export const workResourceLabel = (key) =>
  (WORK_RESOURCES.find((r) => r.key === key) || {}).label || key;

/**
 * 負責角色。用需求書的說法「執行或管理工作是否都已解除」,
 * 不用自創的「主責／代理」—— 刪除檢查那句話才對得回文件。
 * 目前只會產生 manage;execute 先留著不產資料、UI 也不露出。
 */
export const DUTY_ROLE = { MANAGE: "manage", EXECUTE: "execute" };

/**
 * 把一批負責關係整理成「哪一類幾筆」,依 WORK_RESOURCES 的順序,
 * 0 筆的類別不出現（列表的 tag 與刪除阻擋的訊息共用這個結果）。
 */
export function countByResource(assignments = []) {
  return WORK_RESOURCES.map((r) => ({
    ...r,
    count: assignments.filter((a) => a.resource === r.key).length,
  })).filter((r) => r.count > 0);
}
